import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.sass']
})

export class TextEditorComponent implements OnInit {
  @Input() options: string;

  constructor() { }

  ngOnInit() { }

}
